export default "__VITE_ASSET__Cd0wbuC0__"